import React, { useState } from 'react'
import { ProjectProps } from './Project'
import { useTranslation } from 'react-i18next';
import Loading from '../../components/Loading';
import MainBlock from '../../components/MainBlock';
import { TbCopy, TbExternalLink } from 'react-icons/tb';
import { useAsyncEffect } from '../../utils/functions';
import { Admin } from '../../api/API';
import { BoldHeader3, Title } from '../../components/General';
import AlertWrapper from '../../components/AlertWrapper';
import Alert from '../../components/Alert';

const Overview = (props: ProjectProps) => {

  const { t } = useTranslation();
  const [services, setServices] = useState<{ [key: string]: { icon: React.ReactNode, count: number, size?: number } }>({});
  const [isLoading, setIsLoading] = useState(true);
  // get api key
  const [showApiKey, setShowApiKey] = useState(false);
  const [isRetreiving, setIsRetrieving] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [isApiKeyCopied, setIsApiKeyCopied] = useState(false);

  // load services
  useAsyncEffect(async () => {
    let newServices: { [key: string]: { icon: React.ReactNode, count: number, size?: number } } = {};
    setServices(newServices);
    setIsLoading(false);
  }, [props.project]);

  const revealApiKey = async () => {
    setShowApiKey(true);
    setIsRetrieving(true);
    const result = await Admin.getApiKey(props.project.id);
    setIsRetrieving(false);
    setApiKey(result.key || '');
  }

  const copyApiKey = () => {
    navigator.clipboard.writeText(apiKey);
    setIsApiKeyCopied(true);
  }

  return (
    isLoading ? <main className='flex items-center justify-center flex-1'><Loading solid size={8} /></main>
      : <>
        <div className='flex-1 flex flex-col p-4 md:px-8 overflow-auto'>
          <div className='flex items-center justify-between gap-4'>
            <Title>{props.project.name}</Title>
          </div>
          <div className='flex-1 overflow-auto mt-4 flex flex-col'>
            <MainBlock extraclass='flex-1 flex flex-col overflow-auto'>
              {/* project info */}
              <div className='flex flex-col md:flex-row gap-4 p-4'>
                <div className='flex-1'><BoldHeader3>{t('project.overview.project-info')}</BoldHeader3></div>
                <div className='flex flex-col md:w-3/5 gap-4'>
                  <div>
                    <div className='text-sm md:text-base'>{t('project.overview.project-description')}</div>
                    <div className='text-sm font-light'>{props.project.description}</div>
                  </div>
                  {/* <div className='my-2 border-b' />
                  <div>
                    <div className='text-sm md:text-base'>{t('project.overview.admins')} ({props.project.adminIds.length})</div>
                    <div className='flex flex-wrap gap-x-4 gap-y-1 mt-1'>
                      {props.project.adminIds.map(admin => (
                        <div className='text-sm font-light'>{admin.userId}</div>
                      ))}
                    </div>
                  </div>
                  <div className='my-2 border-b' />
                  <div>
                    <div className='text-sm md:text-base'>{t('general.last-update')}</div>
                    <div className='text-sm font-light'>{getStandardTime(new Date(props.project.lastUpdate))}</div>
                  </div> */}
                </div>
              </div>
              <div className='my-4 border-b' />
              {/* access control */}
              <div className='flex flex-col md:flex-row gap-4 p-4'>
                <div className='flex-1'><BoldHeader3>{t('project.overview.access-control')}</BoldHeader3></div>
                <div className='flex flex-col md:w-3/5 gap-4'>
                  <div>
                    <div className='text-sm md:text-base'>{t('general.project')} ID</div>
                    <div className='mt-1 relative bg-gray-100 rounded-lg text-sm px-4 py-2 text-gray-400'>
                      {props.project.id}
                      <button onClick={() => navigator.clipboard.writeText(props.project.id)} className='absolute right-2 top-1/2 -translate-y-1/2 bg-white rounded w-6 h-6 flex items-center justify-center hover:text-primary'><TbCopy /></button>
                    </div>
                  </div>
                  <div className='my-2 border-b' />
                  <div>
                    <div className='text-sm md:text-base'>{t('project.overview.api-key')}</div>
                    <div className='mt-1 flex items-center justify-center bg-gray-100 rounded-lg text-sm px-4 py-1.5 text-gray-400'>
                      {/* API Key */}
                      <button onClick={revealApiKey} className='text-xs text-black bg-white border rounded-lg px-4 py-1'>{t('project.overview.reveal-api-key')}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='my-4 border-b' />
              {/* services */}
              {/* <div className='flex flex-col md:flex-row gap-4 p-4'>
                <div className='flex-1'><BoldHeader3>{t('project.overview.services')}</BoldHeader3></div>
                <div className='flex flex-col md:w-3/5 gap-4'>
                  {services.users.count ? <div className='flex flex-col'>
                    <div className='flex items-center text-sm md:text-base'>{services['users'].icon}{t('sidebar-menu.project.auth')}</div>
                    <div className='mt-2 text-sm font-light'>{t('project.overview.users-count', { count: services['users'].count })}</div>
                  </div> : <></>}
                  {services.databases.count ? <>
                    <div className='my-2 border-b' />
                    <div className='flex flex-col'>
                      <div className='flex items-center text-sm md:text-base'>{services['databases'].icon}{t('sidebar-menu.project.database')} ({services['databases'].count})</div>
                      <div className='mt-2 text-sm font-light'>{t('project.overview.databases-size')}<span className='ml-2'>{getSizeString(services['databases'].size || 0)}</span></div>
                    </div>
                  </> : <></>}
                  {services.storages.count ? <>
                    <div className='my-2 border-b' />
                    <div className='flex flex-col'>
                      <div className='flex items-center text-sm md:text-base'>{services['storages'].icon}{t('sidebar-menu.project.storage')} ({services['storages'].count})</div>
                      <div className='mt-2 text-sm font-light'>{t('project.overview.storages-size')}<span className='ml-2'>{getSizeString(services['storages'].size || 0)}</span></div>
                    </div>
                  </> : <></>}
                  {services.functions.count ? <>
                    <div className='my-2 border-b' />
                    <div className='flex flex-col'>
                      <div className='flex items-center text-sm md:text-base'>{services['functions'].icon}{t('sidebar-menu.project.function')}</div>
                      <div className='mt-2 text-sm font-light'>{t('project.overview.functions-count', { count: services['functions'].count })}</div>
                    </div>
                  </> : <></>}
                </div>
              </div> */}
            </MainBlock>
          </div>
        </div>

        {/* show api key */}
        {showApiKey && <AlertWrapper>
          <Alert
            title={t('project.overview.api-key')}
            maxWidth={480}
            onClose={() => setShowApiKey(false)}
            body={isRetreiving ? <div className='flex justify-center items-center'><Loading solid size={6} /></div> : (
              apiKey ? <div className='mx-1'>
                <div onClick={copyApiKey} className='cursor-pointer text-xs font-light text-gray-400'>Click to copy {isApiKeyCopied && <i className='fa-solid fa-check' />}</div>
                <div onClick={copyApiKey} className='break-all p-2 rounded-lg bg-gray-100 text-gray-400 cursor-pointer text-sm mt-1'>{apiKey}</div>
                <div className='text-xs text-amber-500 mt-2'>{t('project.overview.api-key.description')}</div>
              </div> : <div className='mx-1'>
                <div className='text-sm'>{t('project.overview.api-key.invalid')}</div>
              </div>
            )}
          />  
        </AlertWrapper>}
      </>
  )
}

export default Overview